(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-card-tile-modal"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const openButtons = document.querySelectorAll('.open-modal-btn');
    const modals = document.querySelectorAll('.modal-overlay');

    openButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        const modal = document.getElementById(this.dataset.modal);
        if (modal) {
          modal.classList.add('active');
          document.body.style.overflow = 'hidden';
        }
      });
    });

    modals.forEach(modal => {
      modal.addEventListener('click', function(e) {
        if (e.target.classList.contains('modal-overlay') || e.target.classList.contains('modal-close')) {
          modal.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-download-tile-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const openButtons = document.querySelectorAll('.open-modal-btn')
    const modals = document.querySelectorAll('.modal-overlay')

    openButtons.forEach((btn) => {
      btn.addEventListener('click', function () {
        const modal = document.getElementById(this.dataset.modal)
        if (modal) {
          modal.classList.add('active')
          document.body.style.overflow = 'hidden'
        }
      })
    })

    modals.forEach((modal) => {
      modal.addEventListener('click', function (e) {
        if (e.target.classList.contains('modal-overlay') || e.target.classList.contains('modal-close')) {
          modal.classList.remove('active')
          document.body.style.overflow = ''
        }
      })
    })
  })
  
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      const activeModal = document.querySelector('.modal-overlay.active')
      if (activeModal) {
        activeModal.classList.remove('active')
        document.body.style.overflow = ''
      }
    }
  })

  // Search filter
  document.addEventListener('DOMContentLoaded', function () {
    const searchbar = document.querySelector("#search-download")
    const clearbutton = document.querySelector("#clear-search-btn")
    const prodgrid = document.querySelector("#download-collection")
    const notfound = document.querySelector("#not-found")

    if (!searchbar || !prodgrid) return

    function getCards() {
      return prodgrid.querySelectorAll(".download-card")
    }

    function applyFilter() {
      const cards = getCards()
      const term = searchbar.value.trim().toLowerCase()
      let count = 0

      cards.forEach(card => {
        const title = card.dataset.title.toLowerCase()
        const ok = title.includes(term)

        card.style.display = ok ? 'flex' : 'none'
        if (ok) count++
      });

      notfound.classList.toggle('show', count === 0)
      prodgrid.classList.toggle('hidden', count === 0)
    }

    searchbar.addEventListener('input', applyFilter)

    clearbutton.addEventListener('click', () => {
      searchbar.value = ""
      applyFilter()
    })

    applyFilter()
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-download-tile"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const els = {
      kw: document.querySelector('#search-download'),
      cc: document.querySelectorAll('#downloads-container .card-container'),
      nf: document.querySelector('#not-found'),
      cb: document.querySelector('#clear-search-btn')
    }

    function applyFilter() {
      const k = els.kw.value.trim().toLowerCase()
      let vc = 0
      
      els.cc.forEach(c => {
        const d = c.dataset.keywords.toLowerCase()

        const ok = (d.includes(k))

        c.style.display = ok ? 'block' : 'none'
        if (ok) vc++
      })

      els.nf.classList.toggle('show', vc === 0)
    }

    els.kw.addEventListener('input', applyFilter)
    els.cb.addEventListener('click', () => {
      els.kw.value = ''
      applyFilter()
    })

    applyFilter()
  })

  document.addEventListener('DOMContentLoaded', function() {
    const openButtons = document.querySelectorAll('.open-modal-btn')
    const modals = document.querySelectorAll('.modal-overlay')

    openButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        const modal = document.getElementById(this.dataset.modal)
        if (modal) {
          modal.classList.add('active')
          document.body.style.overflow = 'hidden'
        }
      })
    })

    modals.forEach(modal => {
      modal.addEventListener('click', function(e) {
        if (e.target.classList.contains('modal-overlay') || e.target.classList.contains('modal-close')) {
          modal.classList.remove('active')
          document.body.style.overflow = ''
        }
      })
    })
  })

  } catch(e) { console.error(e); }
})();
})();
